<!--
 * @Author: MancyWang mengxiaowang@sjtu.edu.cn
 * @Date: 2023-01-13 15:17:56
 * @LastEditors: MancyWang mengxiaowang@sjtu.edu.cn
 * @LastEditTime: 2023-04-18 22:02:35
 * @FilePath: \xingou-commecial-plat-frontend\src\App.vue
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <transition name="fade">
    <keep-alive>
    <router-view></router-view>
    </keep-alive>
  </transition>

</template>

<script>
import DevicePixelRatio from './utils/rem';
  export default {
    created(){
      // new DevicePixelRatio().init()
      
    }
  }

</script>
